module.exports = __webpack_public_path__ + "static/media/GAOFEN 2.17929886.czml";